'use client';

import dynamic from 'next/dynamic';

export default function Home() {
  const HeroCarousel = dynamic(() => import('./components/HeroCarousel'), {
    loading: () => (
      <div className="skeleton lg:mt-16 sm:mt-0 md:mt-8 w-full h-[300px] sm:h-[500px] md:h-[600px] lg:h-[700px]"></div>
    ),
    ssr: false,
  });
  const AnimatedHeadline = dynamic(
    () => import('./components/AnimatedHeadline'),
    {
      loading: () => (
        <div className="w-full lg:top-16 sm:top-0 md:top-8 h-[30px] sm:h-[50px] md:h-[60px] lg:h-[70px]"></div>
      ),
      ssr: false,
    }
  );
  const Counters = dynamic(() => import('./components/Counters'), {
    loading: () => (
      <div className="w-full lg:top-16 sm:top-0 md:top-8 h-[30px] sm:h-[50px] md:h-[60px] lg:h-[70px]"></div>
    ),
    ssr: false,
  });
  const AboutUs = dynamic(() => import('./components/AboutUs'), {
    ssr: false,
    loading: () => (
      <div className="skeleton lg:mt-16 sm:mt-0 md:mt-8 w-full h-[300px] sm:h-[500px] md:h-[600px] lg:h-[700px]"></div>
    ),
  });
  const SelectedWorks = dynamic(() => import('./components/SelectedWorks'), {
    loading: () => (
      <div className="skeleton lg:mt-16 sm:mt-0 md:mt-8 w-full h-[900px] sm:h-[1500px] md:h-[1800px] lg:h-[2100px]"></div>
    ),
    ssr: false,
  });
  const OurServices = dynamic(() => import('./components/OurServices'), {
    loading: () => (
      <div className="skeleton lg:mt-16 sm:mt-0 md:mt-8 w-full h-[600px] sm:h-[1000px] md:h-[1200px] lg:h-[1400px]"></div>
    ),
    ssr: false,
  });
  const ClientStories = dynamic(() => import('./components/ClientStories'), {
    loading: () => (
      <div className="skeleton lg:mt-16 sm:mt-0 md:mt-8 w-full h-[300px] sm:h-[500px] md:h-[600px] lg:h-[700px]"></div>
    ),
    ssr: false,
  });

  return (
    <div className="container mx-auto pl-6 pb-6 pr-6 bg-base-100">
      <HeroCarousel />
      <AnimatedHeadline />
      <AboutUs />
      <Counters />
      <SelectedWorks />
      <OurServices />
      <ClientStories />
    </div>
  );
}
